export default "__VITE_ASSET__DWGzC7bp__"